import { imageNames } from "@/src/constants/imageConstants.js";
import fileTypePath from "@/src/paths/fileTypePath.js";

export const attachmentTypes = {
  WHITE: "white",
  GRAY: "gray",
  ARROW: "arrow",
};

export const attachmentTypeConfig = {
  [attachmentTypes.WHITE]: { icon: imageNames.ATTACH_FILE_WHITE },
  [attachmentTypes.GRAY]: { icon: imageNames.ATTACH_FILE_GREY },
  [attachmentTypes.ARROW]: { icon: imageNames.UPLOAD_1_GREY },
};

export const attachmentRendererType = {
  UPLOAD: "upload",
  PREVIEW: "preview",
};

export const attachmentDisplayType = {
  IMAGE: "image",
  VIDEO: "video",
  AUDIO: "audio",
  FILE: "file",
};

export const mimeTypePrefix = {
  IMAGE: "image",
  VIDEO: "video",
  AUDIO: "audio",
};

export const fileExtensionToDisplayType = {
  jpg: attachmentDisplayType.IMAGE,
  jpeg: attachmentDisplayType.IMAGE,
  png: attachmentDisplayType.IMAGE,
  gif: attachmentDisplayType.IMAGE,
  webp: attachmentDisplayType.IMAGE,
  mp4: attachmentDisplayType.VIDEO,
  mov: attachmentDisplayType.VIDEO,
  avi: attachmentDisplayType.VIDEO,
  mkv: attachmentDisplayType.VIDEO,
  webm: attachmentDisplayType.VIDEO,
  mp3: attachmentDisplayType.AUDIO,
  wav: attachmentDisplayType.AUDIO,
  ogg: attachmentDisplayType.AUDIO,
  m4a: attachmentDisplayType.AUDIO,
};

export const fileTypeMapping = {
  pdf: fileTypePath.thumbnail.pdf,
  doc: fileTypePath.thumbnail.doc,
  docx: fileTypePath.thumbnail.doc,
  jpg: fileTypePath.thumbnail.image,
  jpeg: fileTypePath.thumbnail.image,
  png: fileTypePath.thumbnail.image,
  gif: fileTypePath.thumbnail.image,
  webp: fileTypePath.thumbnail.image,
  mp4: fileTypePath.thumbnail.video,
  mov: fileTypePath.thumbnail.video,
  avi: fileTypePath.thumbnail.video,
  mkv: fileTypePath.thumbnail.video,
  webm: fileTypePath.thumbnail.video,
  mp3: fileTypePath.thumbnail.audio,
  wav: fileTypePath.thumbnail.audio,
  ogg: fileTypePath.thumbnail.audio,
  m4a: fileTypePath.thumbnail.audio,
  csv: fileTypePath.thumbnail.csv,
  ppt: fileTypePath.thumbnail.ppt,
  pptx: fileTypePath.thumbnail.ppt,
  xls: fileTypePath.thumbnail.csv,
  xlsx: fileTypePath.thumbnail.csv,
  txt: fileTypePath.thumbnail.default,
  zip: fileTypePath.thumbnail.default,
  rar: fileTypePath.thumbnail.default,
  default: fileTypePath.thumbnail.default,
};

export const getFileTypeIcon = (extension) => {
  return fileTypeMapping[extension] || fileTypeMapping.default;
};

export const getAttachmentDisplayType = (fileName, contentType) => {
  const extension = fileName?.split(".").pop()?.toLowerCase();
  if (fileExtensionToDisplayType[extension]) {
    return fileExtensionToDisplayType[extension];
  }

  if (contentType) {
    const ct = contentType.toLowerCase();
    if (ct === mimeTypePrefix.IMAGE || ct.startsWith(`${mimeTypePrefix.IMAGE}/`)) return attachmentDisplayType.IMAGE;
    if (ct === mimeTypePrefix.VIDEO || ct.startsWith(`${mimeTypePrefix.VIDEO}/`)) return attachmentDisplayType.VIDEO;
    if (ct === mimeTypePrefix.AUDIO || ct.startsWith(`${mimeTypePrefix.AUDIO}/`)) return attachmentDisplayType.AUDIO;
  }

  return attachmentDisplayType.FILE;
};
